import { Controller, useFormContext } from 'react-hook-form';

import { FormFieldContainer } from './form-field-container';
import { NewConvergeInputLabel } from './new-converge-input-label';
import { ReactNode } from 'react';

export interface IFormViewValueFieldProps {
  name: string;
  label?: string;
  containerWidth?: number;
  className?: string;
  renderValue?: (value: unknown) => ReactNode | string | number | undefined;
  tooltip?: string;
}

export const FormViewValueField = ({
  name,
  tooltip,
  label,
  containerWidth = 6,
  className,
  renderValue,
}: IFormViewValueFieldProps) => {
  const { control } = useFormContext();

  // TODO: Fix by removing children
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value } }) => (
        <FormFieldContainer md={containerWidth}>
          <NewConvergeInputLabel label={label} tooltip={tooltip} />

          <span className={className}>
            {renderValue ? renderValue(value) : value}
          </span>
        </FormFieldContainer>
      )}
    />
  );
};
